var moment = require('moment')
var dateutils = require('./dateutils')
var firestoretable = require('./firestoretable')
const state = {
  all: [],
  headers: ['customerAccount', 'name'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  showCreateModal: false,
  showSearchModal: false,
  newCustomer: {
    customerAccount: '',
    name: '',
    error: ''
  },
  searchCustomer: {
    customerAccount: '',
    name: ''
  },
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false,
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
}

const getters = {
  getAll: function (state, getters, rootState) {
    return state.all
  },
  getHeaders: function (state, getters, rootState) {
    let extraHeaders = []
    for (let i = 0; i < state.headers.length; i++) {
      let eachHeader = state.headers[i]
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      })
    }
    return extraHeaders
  }
}

const mutations = {
  setRowsPerPage: function (state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage
  },
  changePageNumber: function (state, newCurrentPage) {
    state.currentPage = newCurrentPage
    // console.log('CHanged state page number to: ' + state.currentPage)
  },
  updateTotalRows: function (state, newTotalRows) {
    state.totalRows = newTotalRows
    // console.log('Mutated totalRows to: ' + state.totalRows)
  },
  selectTableRow: function (state, docId) {
    for (let i = 0; i < state.all.length; i++) {
      if (state.all[i].docId === docId) {
        state.all[i]._rowVariant = 'info'
      } else {
        state.all[i]._rowVariant = ''
      }
    }
  },
  toggleShowCreateModal: function (state, show) {
    state.showCreateModal = show
  },
  setNewCustomerAccount: function (state, customerAccount) {
    state.newCustomer.customerAccount = customerAccount
  },
  setNewCustomerName: function (state, name) {
    state.newCustomer.name = name
  },
  setNewCustomerError: function (state, error) {
    state.newCustomer.error = error
  },
  toggleShowSearchModal: function (state, show) {
    state.showSearchModal = show
  },
  setSearchCustomerAccount: function (state, customerAccount) {
    state.searchCustomer.customerAccount = customerAccount
  },
  setSearchCustomerName: function (state, name) {
    state.searchCustomer.name = name
  },
  toggleShowLoadingAnimation: function (state, show) {
    state.showLoadingAnimation = show
  },
  toggleshowLoadingError: function (state, show) {
    state.showLoadingError = show
  },
  toggleShowNoResult: function (state, show) {
    state.showNoResult = show
  },
  setLoadingErrorMessage: function (state, message) {
    state.loadingErrorMessage = message
  },
  toggleDisabledPagination: function (state, show) {
    state.disabledPagination = show
  }
}

const actions = {
  showAllCustomerAccounts (context, payload) {
    context.state.all = []

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    context.commit('toggleDisabledPagination', true)

    let queryParameters = {
      collectionName: 'customerAccounts',
      flippedSorting: false,
      jumpedPage: false,
      jumpedLimit: 0,
      flippedResult: [],
      orderByField: 'customerAccount',
      orderByDirection: 'asc',
      orderByFlippedDirection: 'desc'
    }

    let docQuery = firestoretable.getCollectionQuery(context, payload, queryParameters)

    firestoretable.queryCollection(docQuery, context, queryParameters, false)

    // count total rows
    context.rootState.realtimeDb.ref('customerAccounts').once('value').then(function (snapshot) {
      if (snapshot.val()) {
        context.commit('updateTotalRows', Number(snapshot.val().rowCount))
      } else {
        let firstQuery = context.rootState.firestoreDB.collection('customerAccounts')
        firstQuery.get().then(function (querySnapshot) {
          context.commit('updateTotalRows', querySnapshot.docs.length)
        })
      }
    })

    // if (context.state.currentPage === 1) {
    // let docQuery = context.rootState.firestoreDB.collection('customerAccounts')
    //   .orderBy('customerAccount')
    //   .limit(context.state.rowsPerPage)
    // docQuery.get().then(function (querySnapshot) {
    //   querySnapshot.forEach(function (doc) {
    //     // console.log(doc.id + '=>' + doc.data())
    //     let documentData = doc.data()
    //     let invoiceObject = {}
    //     for (let eachProp in documentData) {
    //       let propName = eachProp
    //       // console.log('eachProp: ' + eachProp)
    //       if (propName === 'createdDate' && doc.data()[eachProp]) {
    //         let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
    //         invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
    //       } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
    //         let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
    //         invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
    //       } else {
    //         invoiceObject[propName] = doc.data()[eachProp]
    //       }
    //     }
    //     invoiceObject.pairRequestsDocId = doc.id
    //     invoiceObject._rowVariant = ''
    //     context.state.all.push(invoiceObject)
    //   })
    //   context.commit('toggleShowLoadingAnimation', false)
    //   if (context.state.all.length === 0) {
    //     context.commit('toggleShowNoResult', true)
    //   }
    // }).catch(function (err) {
    //   console.log('Error while fetching documents: ' + err)
    //   context.commit('toggleShowLoadingAnimation', false)

    //   context.commit('toggleshowLoadingError', true)
    //   context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
    // })
    // } else {
    //   let lastRowShown
    //   if (context.state.currentPage === 2) {
    //     lastRowShown = context.state.rowsPerPage
    //   } else {
    //     lastRowShown = ((context.state.currentPage - 1) * context.state.rowsPerPage)
    //   }
    //   console.log('lastRowShown: ' + lastRowShown)
    //   let docQuery = context.rootState.firestoreDB.collection('customerAccounts')
    //     .orderBy('customerAccount')
    //   docQuery.get().then(function (querySnapshot) {
    //     let lastVisibleSnapshot = querySnapshot.docs[lastRowShown]
    //     console.log('lastVisibleSnapshot: ' + lastVisibleSnapshot)

    //     let docSubQuery = context.rootState.firestoreDB.collection('customerAccounts')
    //       .orderBy('customerAccount')
    //       .startAt(lastVisibleSnapshot)
    //       .limit(context.state.rowsPerPage)
    //     docSubQuery.get().then(function (subQuerySnapshot) {
    //       subQuerySnapshot.forEach(function (subDoc) {
    //         // console.log(subDoc.id + '=>' + subDoc.data())
    //         let documentData = subDoc.data()
    //         let invoiceObject = {}
    //         for (let eachProp in documentData) {
    //           let propName = eachProp
    //           // console.log('eachProp: ' + eachProp)
    //           // invoiceObject[propName] = subDoc.data()[eachProp]
    //           // context.state.headers.push(propName)
    //           if (propName === 'createdDate' && subDoc.data()[eachProp]) {
    //             let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
    //             invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
    //           } else if (propName === 'updatedDate' && subDoc.data()[eachProp]) {
    //             let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
    //             invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
    //           } else {
    //             invoiceObject[propName] = subDoc.data()[eachProp]
    //           }
    //         }
    //         invoiceObject.pairRequestsDocId = subDoc.id
    //         invoiceObject._rowVariant = ''
    //         context.state.all.push(invoiceObject)
    //       })
    //       context.commit('toggleShowLoadingAnimation', false)
    //       if (context.state.all.length === 0) {
    //         context.commit('toggleShowNoResult', true)
    //       }
    //     })
    //   }).catch(function (err) {
    //     console.log('Error while fetching documents: ' + err)
    //     context.commit('toggleShowLoadingAnimation', false)

    //     context.commit('toggleshowLoadingError', true)
    //     context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
    //   })
    // }
  },
  addCustomerAccount (context, payload) {
    console.log('customerAccount: ' + context.state.newCustomer.customerAccount)
    console.log('name: ' + context.state.newCustomer.name)

    // clear error
    context.commit('setNewCustomerError', '')

    if (context.state.newCustomer.customerAccount) {
      if (context.state.newCustomer.customerAccount.length !== 6) {
        context.commit('setNewCustomerError', 'Customer account must be 6 digits long')
      } else {
        // add
        context.commit('setNewCustomerError', '')

        context.rootState.firestoreDB.collection('customerAccounts')
          .where('customerAccount', '==', context.state.newCustomer.customerAccount)
          .get().then(function (querySnapshot) {
            if (querySnapshot.size === 0) {
              context.rootState.firestoreDB.collection('customerAccounts').add({
                customerAccount: context.state.newCustomer.customerAccount,
                name: context.state.newCustomer.name
              }).then(function (doc) {
                console.log('Customer account added')
                context.commit('toggleShowCreateModal', false)
                // context.dispatch('showAllCustomerAccounts')
              }).catch(function (err) {
                console.error(err)
                context.commit('setNewCustomerError', err)
              })
            } else {
              context.commit('setNewCustomerError', 'Customer account already exist')
            }
          }).catch(function (err) {
            console.error(err)
            context.commit('setNewCustomerError', err)
          })
      }
    }
  },
  searchCustomer (context, payload) {
    console.log('search customer account: ' + context.state.searchCustomer.customerAccount)
    console.log('search customer name: ' + context.state.searchCustomer.name)

    if (!context.state.searchCustomer.name && !context.state.searchCustomer.customerAccount) {
      return
    }

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    context.state.all = []
    context.state.detailAll = []
    context.commit('updateTotalRows', 0)

    let docQuery = context.rootState.firestoreDB.collection('customerAccounts')
    if (context.state.searchCustomer.customerAccount && context.state.searchCustomer.customerAccount.length > 0) {
      docQuery = docQuery.where('customerAccount', '==', context.state.searchCustomer.customerAccount)
    }
    if (context.state.searchCustomer.name && context.state.searchCustomer.name.length > 0) {
      docQuery = docQuery.where('name', '==', context.state.searchCustomer.name)
    }

    if (!docQuery) {
      return
    }

    // docQuery = docQuery.limit(context.state.rowsPerPage)

    docQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.size)
      querySnapshot.forEach(function (doc) {
        // console.log(doc.id + '=>' + doc.data())
        let documentData = doc.data()
        let invoiceObject = {}
        for (let eachProp in documentData) {
          let propName = eachProp
          // console.log('eachProp: ' + eachProp)
          if (propName === 'orderDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY')
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else {
            invoiceObject[propName] = doc.data()[eachProp]
          }
        }
        invoiceObject.id = doc.id
        invoiceObject._rowVariant = ''
        context.state.all.push(invoiceObject)
      })
      context.commit('toggleShowSearchModal', false)
      context.commit('toggleShowLoadingAnimation', false)
      if (context.state.all.length === 0) {
        context.commit('toggleShowNoResult', true)
      }
    }).catch(function (err) {
      console.log('Error while fetching documents in invoice collection: ' + err)
      context.commit('toggleShowSearchModal', false)
      context.commit('toggleShowLoadingAnimation', false)

      context.commit('toggleshowLoadingError', true)
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
    })
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/customeraccountsstoremodule.js